// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDP3xK-_MQu5Lek6FWbFHh6MBaMtCKKDqY",
  authDomain: "huchaonline-137c6.firebaseapp.com",
  projectId: "huchaonline-137c6",
  databaseURL: "https://huchaonline-137c6-default-rtdb.europe-west1.firebasedatabase.app/",
  storageBucket: "huchaonline-137c6.firebasestorage.app",
  messagingSenderId: "131336817530",
  appId: "1:131336817530:web:e426c4e710c1576ae564c3",
  measurementId: "G-19GY4VVDXZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Inicializar la base de datos y EXPORTARLA para que App.js la pueda usar
export const database = getDatabase(app);